import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=6a2dbc04&scoped=true&"
import script from "./FilterCard.vue?vue&type=script&lang=js&"
export * from "./FilterCard.vue?vue&type=script&lang=js&"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=6a2dbc04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2dbc04",
  null
  
)

export default component.exports